import gql from 'graphql-tag'

// USED IN: SCHEDULE, PATIENT_NOTES, VEIL, ACTION_STREAM
export const GetAppointments = gql`
  query GetAppointments($ownerId: ID!, $startsAtRangeBeginning: String!, $startsAtRangeEnd: String!) {
    appointments(input: {
      ownerId: $ownerId,
      startsAtRangeBeginning: $startsAtRangeBeginning,
      startsAtRangeEnd: $startsAtRangeEnd,
      includeStatuses: true,
      filterInternalAppointments: true
    }) {
      count,
      results {
        id,
        startsAt,
        type,
        patient {
          id,
          person {
            firstName,
            middleName,
            lastName,
            dateOfBirth,
            gender
          }
        },
        compositionId,
        noteId,
        noteStatus,
        noteSubmissionStatus {
          warning {
            type,
            message
          },
          finalDestination
        }
      }
    }
  }
`

export const GetAppointmentsFromEMR = gql`
  query GetAppointmentsFromEMR($organizationId: ID!, $ownerId: ID!, $startsAtRangeBeginning: String!, $startsAtRangeEnd: String!, $source: AppointmentSource, $jobId: ID) {
    appointmentsEMR(input: {
      organizationId: $organizationId,
      ownerId: $ownerId,
      startsAtRangeBeginning: $startsAtRangeBeginning,
      startsAtRangeEnd: $startsAtRangeEnd,
      includeStatuses: true,
      source: $source,
      jobId: $jobId
    }) {
      count,
      results {
        id,
        startsAt,
        type,
        patient {
          id,
          person {
            firstName,
            middleName,
            lastName,
            dateOfBirth,
            gender
          }
        },
        compositionId,
        noteId,
        noteStatus,
        noteSubmissionStatus {
          warning {
            type,
            message
          },
          finalDestination
        }
      }
    }
  }
`

export const CreateOrUpdateAppointment = gql`
  mutation CreateOrUpdateAppointment($organizationId: ID, $appointment: AppointmentInput!) {
    createOrUpdateAppointment(input: {
      organizationId: $organizationId,
      appointment: $appointment
    }) {
      appointment {
        id
      }
    }
  }
`
